import { useCallback, useState } from 'react';
import { hasWhiteBorder } from '../utils/imageBorder';

/** SAM-1105: `onFileChosen` for S3ImageUpload; `warn` is true while the last picked image has a white border. */
export const useWhiteBorderCheck = () => {
  const [warn, setWarn] = useState(false);
  const onFileChosen = useCallback((file: File) => {
    setWarn(false);
    void hasWhiteBorder(file).then(setWarn);
  }, []);
  return { warn, onFileChosen };
};
